/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Table_SectionInputs */

const en_clients_table_section = /** @type {(inputs: Clients_Table_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All clients`)
};

const pt_br2_clients_table_section = /** @type {(inputs: Clients_Table_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os clientes`)
};

/**
* | output |
* | --- |
* | "All clients" |
*
* @param {Clients_Table_SectionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_table_section = /** @type {((inputs?: Clients_Table_SectionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Table_SectionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_table_section(inputs)
	return pt_br2_clients_table_section(inputs)
});